import React, { useState, useEffect } from 'react';

const statusStyles = {
  ok: { color: 'lightgreen', label: '[ok]' },
  warning: { color: 'gold', label: '[!]' },
  error: { color: 'red', label: '[x]' },
};


function TasksPage() {
   
  const [statusData, setStatusData] = useState([]);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await import('./statusData.js?' + Date.now());
        setStatusData(res.default || []);
      } catch (err) {
        console.error('Error loading status data:', err);
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 10000);

    return () => clearInterval(interval);
  }, []);

  const latestStatuses = {};
  for (const item of statusData) {
    if (!latestStatuses[item.id] || item.status === 'error') {
      latestStatuses[item.id] = item;
    }
  }

  return (
    <div style={{
      maxWidth: '800px',
      margin: '40px auto',
      padding: '20px',
      border: '1px solid #444',
      borderRadius: '10px',
      backgroundColor: '#1e1e1e',
      color: 'white',
      textAlign: 'left'
    }}>
    <h2 style={{ marginBottom: '20px' }}>Nereshonnie zadaci</h2>

    {/* spisok zadch avtomaticeski */}

    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      {Object.values(latestStatuses).map((item, index) => (
        <li key={index} style={{ color: statusStyles[item.status].color, marginBottom: '10px' }}>
          {statusStyles[item.status].label} {item.message}
        </li>
      ))}
    </ul>
  </div>
);
}


export default TasksPage;
